import { createReducer, Action, on} from '@ngrx/store';
import { createEntityAdapter, Dictionary, EntityAdapter } from '@ngrx/entity';
import * as fromActions from './api-keys.actions';

import { ApiKey } from '@app/core/models/newsboard';
import { Pagination } from '@app/core/models';
import { TableState } from '@app/shared/filters/filters-model';

export const feature = 'details';


export const adapter: EntityAdapter<Partial<ApiKey>> =
 createEntityAdapter<Partial<ApiKey>>({
  selectId: (e) => e.id
 });

export interface State {
  apiKeys: TableState<Partial<ApiKey>>;
}

export const initialState: State = {
  apiKeys: {
    data: adapter.getInitialState(),
    pagination: {
      ...Pagination,
      pageIndex: 0,
      pageSize: 10,
    },
    sort: {
      active: 'createdDate',
      direction: 'desc'
    },
    defaultSort: {
      active: 'createdDate',
      direction: 'desc'
    },
    isLoading: false,
    resetIndex: false,
  },
};

const tableReducer = createReducer(
  initialState,
  on(fromActions.getApiKeysRequest, (state) => ({
    ...state,
    apiKeys: {
      ...state.apiKeys,
      isLoading: true
    }
  })),
  on(fromActions.getApiKeysSuccess, fromActions.getApiKeysFailure, (state) => ({
    ...state,
    apiKeys: {
      ...state.apiKeys,
      isLoading: false
    }
  })),
  on(fromActions.getApiKeysSuccess, (state, {data, pagination}) => ({
    ...state,
    apiKeys: {
      ...state.apiKeys,
      data: adapter.setAll(data, state.apiKeys.data),
      pagination,
      resetIndex: false,
    }
  })),
  on(fromActions.deleteApiKeysSuccess, fromActions.addApiKeysSuccess, (state) => ({
    ...state,
    apiKeys: {
      ...state.apiKeys,
      resetIndex: true
    }
  })),
  on(fromActions.changeApiKeysSort, (state, {active, direction}) => ({
    ...state,
    apiKeys: {
      ...state.apiKeys,
      sort: {
        active,
        direction
      }
    }
  })),
  on(fromActions.changeApiKeysPagination, (state, {pageIndex, pageSize}) => ({
    ...state,
    apiKeys: {
      ...state.apiKeys,
      pagination: {
        ...state.apiKeys.pagination,
        pageIndex,
        pageSize
      }
    }
  })),
 
  on(fromActions.clearAll, (state) => ({
    ...initialState
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return tableReducer(state, action);
}


export const getApiKeys = (state: State) => state.apiKeys;

export const getPagination = (table: TableState<Partial<ApiKey>>) => table.pagination;
export const getSort = (table: TableState<Partial<ApiKey>>) => table.sort;
export const getIsLoading = (table: TableState<Partial<ApiKey>>) => table.isLoading;

export const getRequestData = ({pagination, sort, resetIndex}: TableState<Partial<ApiKey>>) => ({
  pageIndex: pagination.pageIndex,
  pageSize: pagination.pageSize,
  sort,
  resetIndex});

export const getTableData = (table: TableState<Partial<ApiKey>>) => adapter.getSelectors().selectAll(table.data);

// Pagination fields
export const getPageSize = (pagination: Pagination) => pagination.pageSize;
export const getPageIndex = (pagination: Pagination) => pagination.pageIndex;
export const getTotalCount = (pagination: Pagination) => pagination.totalCount;

// Filters fields
export const getEntitiesByIds = (entities: Dictionary<ApiKey>, ids: string[]): ApiKey[] => ids.map(id => entities[id]);
